// extracted by mini-css-extract-plugin
module.exports = {"preview":"styles_preview__3qSEm","header":"styles_header__3p3eq","previewContainer":"styles_previewContainer__2Uv7f","previewCover":"styles_previewCover__48gpR"};